import { useCallback, useEffect, useState } from "react";
import { api, formatApiError } from "@/lib/api";

export function useEntityList(collection) {
  const [items, setItems] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState("");

  const load = useCallback(async () => {
    setLoading(true);
    try {
      const { data } = await api.get(`/admin/content/${collection}`);
      setItems(data || []);
      setError("");
    } catch (e) {
      setError(formatApiError(e));
    } finally {
      setLoading(false);
    }
  }, [collection]);

  useEffect(() => {
    load();
  }, [load]);

  const create = async (data) => {
    const res = await api.post(`/admin/content/${collection}`, { data });
    setItems((arr) => [...arr, res.data]);
  };

  const update = async (id, data) => {
    const res = await api.put(`/admin/content/${collection}/${id}`, { data });
    setItems((arr) => arr.map((it) => (it.id === id ? res.data : it)));
  };

  const remove = async (id) => {
    await api.delete(`/admin/content/${collection}/${id}`);
    setItems((arr) => arr.filter((it) => it.id !== id));
  };

  const move = async (id, dir) => {
    const idx = items.findIndex((it) => it.id === id);
    const swapIdx = idx + dir;
    if (idx < 0 || swapIdx < 0 || swapIdx >= items.length) return;
    const newArr = [...items];
    [newArr[idx], newArr[swapIdx]] = [newArr[swapIdx], newArr[idx]];
    setItems(newArr);
    try {
      await api.post(`/admin/content/${collection}/reorder`, { ids: newArr.map((it) => it.id) });
    } catch (e) {
      load();
    }
  };

  return { items, loading, error, create, update, remove, move };
}
